<template>
  <div :id="component.alert.id" class="popup modal alertType" role="dialog" aria-hidden="true" aria-modal="true" tabindex="-1">
    <div class="pop-bg-close ui-pop-close" role="button" aria-label="팝업창 닫기" @click="closeCallBack"></div>
    <article class="pop-wrap">
      <div class="pop-body">
        <div class="section pre-line t-center alert-txt" tabindex="0">
          <template v-if="component.alert.useHtml">
            <div v-html="component.alert.message"></div>
          </template>
          <template v-else>
            {{ component.alert.message }}
          </template>
        </div>
      </div>
      <div class="bottom-fixed">
        <div class="btn-wrap">
          <div class="flex" v-if="component.alert.btnObj.btnType !== ''">
            <button v-if="component.alert.btnObj.btnType !== 'singleButton'" type="button" class="btn btn-gray" @click="closeCallBack">{{ component.alert.btnObj.cancel }}</button>
            <button type="button" class="btn btn-primary" @click="selectCallBack">{{ component.alert.btnObj.confirm }}</button>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script setup>

import {inject, onMounted} from "vue";
import {togglePop} from "@/utils/commonUi";

const component = inject('$component');

//팝업창 확인 이벤트
const selectCallBack = () => {
  if (component.alert.fn.fnSelect) {
    component.alert.fn.fnSelect();
  }
  toggleClose();
}

//팝업창 취소 이벤트
const closeCallBack = () => {
  if (component.alert.fn.fnClose) {
    component.alert.fn.fnClose();
  }
  toggleClose();
}

//팝업창 닫기
const toggleClose = () => {
  togglePop(component.alert.id, false);
  component.alert.fn.fnReset();
}

onMounted(() => {
  togglePop(component.alert.id, true);
})
</script>

<style scoped lang="scss">

</style>